export default __webpack_public_path__ + "static/lutein-specialisti-VESKA_STOYANOVA-2a3f089b5e2b99d179ca1bf19d878e14.jpg";